// transaction-history.interface.ts
export interface TransactionHistory {
    walletTransactionsList: WalletTransactionsList;
    code: number;
    message: string;
    success?: boolean;
  }
  
  interface WalletTransactionsList {
    rewards: Rewards;
    cash: Cash;
    payments: Payments;
  }
  export const EXCEL_COLUMN_MAPPING = {
    3: 'C',
    4: 'D',
    5: 'E',
    6: 'F',
    7: 'G',
    8: 'H',
    9: 'I',
    10: 'J',
    11: 'K',
    12: 'L',
    13: 'M',
    14: 'N'
  }
  
  interface Rewards {
    rewardsEarn: RewardEarn[];
    rewardsSpends: RewardSpend[];
  }
  
  export interface RewardEarn {
    sourceSystem: string;
    productName: string;
    earnDate: string;
    earnCategory: string;
    earnIdentifier: string;
    earnIdentifierDescription: string;
    pointsEarned: string;
    pointsAmount: string;

    // ✅ For NextGen 
    transactionID?: string; 
    earnCategoryDescription?: string;
  }
  
  export interface RewardSpend {
    sourceSystem: string;
    productName: string;
    spendDate: string;
    spendCategory: string;
    spendIdentifier: string;
    spendIdentifierDescription: string;
    pointSpend: string;
    paymentAmount: string;

    // ✅ For NextGen
    transactionID?: string;
  }
  
  interface Cash {
    cashEarn: CashEarn[];
    cashSpend: CashSpend[];
  }
  
  export interface CashEarn {
    sourceSystem: string;
    productName: string;
    earnDate: string;
    earnCategory: string;
    earnIdentifier: string;
    earnIdentifierDescription: string;
    cashEarned: string;
  }
  
  export interface CashSpend {
    sourceSystem: string;
    productName: string;
    spendDate: string;
    spendCategory: string;
    spendIdentifier: string;
    spendIdentifierDescription: string;
    spendAmount: string;
    spendMethod: string;
    spendAccountRedacted: string;
    spendAccountRedactedDescription: string;
  }
  
  export interface Payments {
    invoicePayments: InvoicePayment[];
    claimPayments: ClaimPayment[];
  }
  
  export interface InvoicePayment {
    sourceSystem: string;
    productName: string;
    paymentDate: string;
    paymentCategory: string;
    paymentIdentifier: string;
    paymentIdentifierDescription: string;
    paymentTotal: string;
    paymentDetails: PaymentDetails;
  }
  
  export interface PaymentDetails {
    rewardsAmount?: string;
    cashAmount?: string;
    paymentAmount?: string;
    paymentMethod: string;
  }
  
  export interface ClaimPayment {
    sourceSystem: string;
    productName: string;
    paymentDate: string;
    paymentCategory: string;
    paymentIdentifier: string;
    paymentIdentifierDescription: string;
    paymentAmount: string;
    paymentMethod: string;
    paymentReferenceGUID: string;
  }
  